import { ProjectRoleType } from "@/features/projects/types";

export interface DemoAccountProject {
  name: string;
  role: ProjectRoleType;
}

export interface DemoAccount {
  name: string;
  email: string;
  password: string;
  projects: DemoAccountProject[];
  note: string;
}

/**
 * Mirrors the accounts marked as featured in the server's demo seeder
 * (Infrastructure/Persistence/Seeders/Demo/DemoUsers.cs). The three accounts
 * cover the three project roles, so a visitor can choose how much of the
 * product they are able to change.
 *
 * Keep this in step with the seeder - the roles and project names listed here
 * are what a visitor is promised before they sign in.
 */
export const DEMO_ACCOUNTS: DemoAccount[] = [
  {
    name: "Priya Mehta",
    email: "priya@demo.com",
    password: "P455w0rd1!",
    projects: [
      { name: "Customer Portal", role: "Admin" },
      { name: "Internal Dashboard", role: "Admin" },
      { name: "API Gateway", role: "Developer" },
    ],
    note: "Full control of Customer Portal - manage members, edit settings and work every ticket.",
  },
  {
    name: "James Carter",
    email: "james@demo.com",
    password: "P455w0rd1!",
    projects: [
      { name: "Mobile App v2", role: "Admin" },
      { name: "Customer Portal", role: "Developer" },
      { name: "API Gateway", role: "Developer" },
    ],
    note: "Raise, edit and close tickets across three projects. Admin on the paused mobile rebuild.",
  },
  {
    name: "Harry Buxton",
    email: "harry@demo.com",
    password: "P455w0rd1!",
    projects: [
      { name: "Customer Portal", role: "Viewer" },
      { name: "Mobile App v2", role: "Viewer" },
      { name: "Internal Dashboard", role: "Viewer" },
    ],
    note: "Read-only across three projects - browse every board, ticket and discussion, but change nothing.",
  },
];
